(ns common.schema.entities.fee.schema
  (:require [common.schema.schema-utils :as su]
            [common.schema.entities.related-entities :as related-entities]))

(def fees-related-entities-attributes
  [:common/related-entities-oppo
   :common/related-entities-company
   :common/related-entities-fundraising-opportunities
   :common/related-entities-person
   :common/related-entities-fund])

(def related-entities
  (->> related-entities/related-entities
       (filter (fn [[related-entities-attribute _]]
                 (some #{related-entities-attribute} fees-related-entities-attributes)))))

(def schema
  (concat (su/option-field :fee/payer "Fee payer" {:authorization            su/access-user-user
                                                   :default-field-visibility :in-use-disabled})
          (su/currency-field :fee/cur-amount "Amount" {:authorization            su/access-user-user
                                                       :default-field-visibility :in-use-disabled
                                                       :constraints              {}})
          (su/option-field :fee/status "Fee status" {:authorization            su/access-user-user
                                                     :default-field-visibility :in-use-disabled})
          (su/date-field :fee/date-fee-date "Fee date" {:authorization            su/access-user-user
                                                        :default-field-visibility :in-use-disabled})
          (su/text-simple-field :fee/note "Note" {:authorization            su/access-user-user
                                                  :default-field-visibility :in-use-disabled})
          (su/option-field :fee/type "Fee type" {:authorization            su/access-user-user
                                                 :default-field-visibility :in-use-disabled})
          (su/option-field :fee/secondary-type "Secondary fee type" {:authorization            su/access-user-user
                                                                     :default-field-visibility :in-use-disabled})
          related-entities))
